import { Spacer, TikTokFilled } from '@sparemin/blockhead';
import React from 'react';
import { Step } from 'components/SteppedModal';
import SocialShareModalFooterAuthButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterAuthButton';
import { TikTokSocialShareStep } from '../../types';
import TikTokAuthorizationStep from './TikTokAuthorizationStep';

export default function useTikTokAuthorizationStep(): Step<
  TikTokSocialShareStep
> {
  return {
    id: 'authorization',
    component: <TikTokAuthorizationStep />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <SocialShareModalFooterAuthButton key="auth">
        <Spacer
          orientation="horizontal"
          space="8px"
          align="center"
          justify="center"
        >
          <TikTokFilled width="16px" height="18px" />
          <span>Continue with TikTok</span>
        </Spacer>
      </SocialShareModalFooterAuthButton>,
    ],
  };
}
